import type PlainDate from '@Domain/PlainDate';

const monthFormatter = new Intl.DateTimeFormat('fr-FR', { month: 'long' });

const formatDay = (date: PlainDate): string => (date.day === 1 ? '1er' : String(date.day));

const formatMonth = (date: PlainDate): string => monthFormatter.format(date.toCalendar());

/** "du 8 au 30 septembre 2026"; the month and the year are repeated only when they differ. */
const formatPeriodRange = (from: PlainDate, to: PlainDate): string => {
	if (from.toApi() === to.toApi()) {
		return `le ${formatDay(to)} ${formatMonth(to)} ${to.year}`;
	}

	if (from.year !== to.year) {
		return `du ${formatDay(from)} ${formatMonth(from)} ${from.year} au ${formatDay(to)} ${formatMonth(to)} ${to.year}`;
	}

	if (from.month !== to.month) {
		return `du ${formatDay(from)} ${formatMonth(from)} au ${formatDay(to)} ${formatMonth(to)} ${to.year}`;
	}

	return `du ${formatDay(from)} au ${formatDay(to)} ${formatMonth(to)} ${to.year}`;
};

export default formatPeriodRange;
